module.exports = __webpack_public_path__ + "static/media/tortue-bleu.a21ec3b3.gif";